import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

// Fase 7/8 da migração (docs/ROTEIRO-MIGRACAO-QUALITY.md): checa se o sistema
// está em modo manutenção, pra bloquear o acesso durante a troca de servidor
// (ninguém grava dados enquanto o banco final é copiado). Verifica de novo a
// cada 20s, mesmo com o app já aberto, pra pegar quem já estava logado quando
// a manutenção for ligada.
export function useManutencao() {
  const [manutencao, setManutencao] = useState(null); // null = ainda não checou

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const { data, error } = await supabase
          .from('sistema_manutencao')
          .select('ativo, mensagem')
          .eq('id', 1)
          .maybeSingle();
        if (cancelled) return;
        if (error || !data) { setManutencao({ ativo: false }); return; }
        setManutencao(data);
      } catch (_) {
        // Falha de rede/tabela ainda não existe: nunca bloqueia por engano.
        if (!cancelled) setManutencao({ ativo: false });
      }
    };

    check();
    const interval = setInterval(check, 20000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return manutencao; // null enquanto carrega, depois { ativo, mensagem }
}
